import type {
  IndustryAdmin,
  IndustryCreateInput,
  IndustryOption,
  IndustryReorderInput,
  IndustryUpdateInput,
} from "@app/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export const industriesApi = {
  // 選択肢（guest 可・active のみ）
  list: () => api.get<IndustryOption[]>("/industries"),
  // 保守用一覧（admin・非活性含む・影響企業数つき）
  listAdmin: () => api.get<IndustryAdmin[]>("/industries?includeInactive=true"),
  create: (input: IndustryCreateInput) => api.post<IndustryAdmin>("/industries", input),
  update: (code: string, input: IndustryUpdateInput) =>
    api.patch<IndustryAdmin>(`/industries/${code}`, input),
  reorder: (items: IndustryReorderInput) => api.patch<IndustryOption[]>("/industries/order", items),
  merge: (code: string, targetCode: string) =>
    api.post<{ movedCount: number }>(`/industries/${code}/merge-into/${targetCode}`),
};

// 選択肢の取得（フォーム・検索で共有）。業種は運用中に変わりうるので staleTime は短め。
export function useIndustryOptions() {
  return useQuery({
    queryKey: ["industries", "options"],
    queryFn: industriesApi.list,
    staleTime: 60_000,
  });
}
